import React, { type ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../../ui-components';

interface SddLocationSelectorProps {
    bopisSddFontSize: 'small' | 'base';
    sddDescription: string;
    sddZipCode?: string;
    isSddSelected: boolean;
    isFetchingSddStore: boolean;
    isSddStoreEligibleOrNull: boolean | undefined;
    sddZipCodeComponent: (chunks: ReactNode[]) => React.ReactElement;
}

export const SddLocationSelector: React.FC<SddLocationSelectorProps> = ({
    bopisSddFontSize,
    sddDescription,
    sddZipCode,
    isSddSelected,
    isFetchingSddStore,
    isSddStoreEligibleOrNull,
    sddZipCodeComponent,
}) => {
    if (!isSddSelected || isFetchingSddStore) {
        return null;
    }

    if (isSddStoreEligibleOrNull) {
        return (
            <Text id="search-filters-sdd-label" size={bopisSddFontSize} style="bold">
                <FormattedMessage
                    id="sdd.deliver.to.zipCode"
                    defaultMessage="Deliver to <sddComponent>{zipCode}</sddComponent>"
                    values={{
                        sddComponent: sddZipCodeComponent,
                        zipCode: sddZipCode ?? 'Enter Location',
                    }}
                />
            </Text>
        );
    }

    return (
        <Flex data-testid="search-filters-sdd-container" gap={1}>
            <Text id="search-filters-sdd-store-pickup-label" size={bopisSddFontSize} style="bold">
                {sddDescription}
            </Text>

            <Text id="search-filters-sdd-store-not-available-label" size={bopisSddFontSize}>
                <FormattedMessage id="not.available.for" defaultMessage="Not available for" />
            </Text>

            {sddZipCodeComponent([sddZipCode])}
        </Flex>
    );
};
